import React, { Component } from 'react';

class Footer extends Component {

    render() {
        const year = new Date().getFullYear()
        return (
            <footer className="footer-container hide">
                <span>&copy; {year} - EKVR</span>
            </footer>
        );
    }

}

export default Footer;
